<template>
  <div class="ccui-home-navigation" ref="noPrintTop">
    <!-- 面包屑 -->
    <el-breadcrumb
      class="ccui-home-navigation-crumbs-container"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }" v-if="isShowPortal"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-for="(item, index) in currBreadCrumb"
        :to="item.path"
        :key="index"
      >
        <span
          class="ccui-home-curr-crumb"
          v-if="index === currBreadCrumb.length - 1"
          :title="item.title"
          >{{ item.title }}</span
        >
        <span v-else>{{ item.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "baseBreadCrumb",
  props: {
    currBreadCrumb: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowPortal: {
      //面包屑是否显示 首页（加这个是为了，搜索页面面包屑不显示 首页）
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .is-link:hover {
  color: #0089ef;
}
.ccui-home-curr-crumb {
  display: inline-block;
  width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
